import { createStyles, alpha, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      minHeight: 25,
    },
    lowerToolBar: {
      minHeight: 20,
      backgroundColor: theme.palette.lowerToolBarContainerColor.main,
      borderTop: '1px solid #d9d9d9',
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha('#000000', 0.15),
      '&:hover': {
        backgroundColor: alpha('#000000', 0.25),
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#808080',
    },
    inputRoot: {
      color: 'black',
      height: 20,
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '20ch',
        },
      },
    },

    popUpMargin: {
      float: 'right',
      maxWidth: 600,
      // backgroundColor: '#ffffff',
      position: 'absolute',
      right: 0,
      margin: 0,
      // overflow: 'scroll',
      // width: 400,
      // backgroundColor: theme.palette.background.paper,
      // border: '2px solid #000',
      boxShadow: theme.shadows[1],
      // padding: theme.spacing(2, 4, 3),
      padding: theme.spacing(0, 0, 0),
    },
    button: {
      height: 22,
      margin: 1,
    },
  }),
);
